import { useState, useCallback, useEffect, useRef } from 'react';

let _dispatch = null;

export const dispatchDriverToast = (t) => _dispatch?.(t);

export function useDriverToast() {
  const [toasts, setToasts] = useState([]);
  const timeoutsRef = useRef(new Map());

  const removeToast = useCallback((id) => {
    const tid = timeoutsRef.current.get(id);
    if (tid) {
      clearTimeout(tid);
      timeoutsRef.current.delete(id);
    }
    setToasts((prev) => prev.filter((x) => x.id !== id));
  }, []);

  const addToast = useCallback(
    ({ type, message, duration = 4000 }) => {
      const id = Date.now();
      setToasts((prev) => [...prev, { id, type, message }]);
      const tid = setTimeout(() => {
        removeToast(id);
      }, duration);
      timeoutsRef.current.set(id, tid);
      return id;
    },
    [removeToast]
  );

  useEffect(() => {
    _dispatch = addToast;
    return () => {
      _dispatch = null;
      timeoutsRef.current.forEach(clearTimeout);
      timeoutsRef.current.clear();
    };
  }, [addToast]);

  const toast = {
    error: (msg) => addToast({ type: 'error', message: msg }),
    warning: (msg) => addToast({ type: 'warning', message: msg }),
    success: (msg) => addToast({ type: 'success', message: msg }),
  };

  return { toasts, toast };
}
